import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const AlignRightIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <rect
      fill={color}
      height="1.53125"
      rx="0.765625"
      width="14"
      x="1"
      y="2.8125"
    />
    <rect
      fill={color}
      height="1.53125"
      rx="0.765625"
      width="10.5"
      x="4.5"
      y="6.09375"
    />
    <rect
      fill={color}
      height="1.53125"
      rx="0.765625"
      width="7"
      x="8"
      y="9.375"
    />
    <rect
      fill={color}
      height="1.53125"
      rx="0.765625"
      width="10.5"
      x="4.5"
      y="12.6562"
    />
  </AccessibleSVG>
);

export default AlignRightIcon;
